import axios from "axios"

const { default: Links } = require("shared/constants/Links")

const Verification = {
    verify: async (r, q) => {
        return axios.get(Links.verification.verify, {
            params: {
                r: r,
                q: q
            }
        })
    }
}

export default Verification